import { Request, BaseApiUrl, getExportExcel,postExportExcel  } from "./api";
/*
// 销售过磅-导出
export const DownWeighingSaleOutHistry = (params,title) => {
 return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingSaleOutHistry`,params,title);
};
*/

//所有报表接口入口

// 原材料耗料报表
export const GetReportManufacture = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufacture`, { params: params });
};
// 原材料耗料报表-导出
export const DownReportManufacture = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufacture`, params, title);
};

// 原材料入库报表
export const GetReportMatReceive = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportMatReceive`, { params: params });
};
// 原材料入库报表-导出
export const DownReportMatReceive = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportMatReceive`, params, title);
};

// 生产日报表
export const GetReportProjectDay = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportProjectDay`, { params: params });
};
// 生产日报表-导出
export const DownReportProjectDay = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportProjectDay`, params, title);
};

// 工程耗料报表
export const GetReportManufactureProject = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufactureProject`, { params: params });
};
// 工程耗料报表-导出
export const DownReportManufactureProject = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufactureProject`, params, title);
};


// 任务完成率报表
export const GetReportProdTask = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportProdTask`, { params: params });
};
// 任务完成率报表-导出
export const DownReportProdTask = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportProdTask`, params, title);
};

// 获取罐子库存图数据
export const GetStockReport = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetStockReport`, { params: params });
};
//获取销售出货最后一个单据编号+1
export const geLastNumberNo = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GeLastNumberNo`, { params: params });
};


// 进料过磅材料明细报表
export const GetWeighingIn = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingIn`, { params: params });
};
// 进料过磅材料明细报表-导出
export const DownWeighingIn = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingIn`, params, title);
};

// 生产明细表
export const GetProdOutMasterDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdOutMasterDetail`, { params: params });
};
// 生产明细表导出
export const DownProdOutMasterDetail = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdOutMasterDetail`, params, title);
};

// 生产统计表
export const GetProdOutMasterGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdOutMasterGroup`, { params: params });
};
// 生产统计表导出
export const DownProdOutMasterGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdOutMasterGroup`, params, title);
};

// 生产统计表
export const GetProdTaskDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdTaskDetail`, { params: params });
};
// 任务单统计导出
export const DownProdTaskDetail = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdTaskDetail`, params, title);
};

// 进料过磅材料统计报表
export const GetWeighingInGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingInGroup`, { params: params });
};
// 进料过磅材料统计报表-导出
export const DownWeighingInGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingInGroup`, params, title);
};

// 出料过磅报表
export const GetWeighingout = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingout`, { params: params });
};
// 出料过磅报表-导出
export const DownWeighingout = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingout`, params, title);
};
// 销售过磅明细报表
export const GetWeighingInSaleOutDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingInSaleOutDetail`, { params: params });
};
// 销售过磅明细报表-导出
export const DownWeighingInSaleOutDetail = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingInSaleOutDetail`, params, title);
};

// 销售过磅统计报表
export const GetWeighingInSaleOutGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingInSaleOutGroup`, { params: params });
};
// 销售过磅统计报表-导出
export const DownWeighingInSaleOutGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingInSaleOutGroup`, params, title);
};
// 出料过磅统计报表
export const GetWeighingoutGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetWeighingoutGroup`, { params: params });
};
// 出料过磅统计报表-导出
export const DownWeighingoutGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownWeighingoutGroup`, params, title);
};
// 消耗合计报表
export const GetManufactureAmount = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetManufactureAmount`, { params: params });
};
// 消耗合计报表-导出
export const DownManufactureAmount = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownManufactureAmount`, params, title);
};

// 工程耗料合计报表
export const GetReportManufactureProjectAmount = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufactureProjectAmount`, { params: params });
};
// 工程耗料合计报表-导出
export const DownReportManufactureProjectAmount = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufactureProjectAmount`, params, title);
};
// 强度等级耗料合计报表
export const GetReportManufactureGradeAmount = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufactureGradeAmount`, { params: params });
};
// 强度等级耗料合计报表-导出
export const DownReportManufactureGradeAmount = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufactureGradeAmount`, params, title);
};

// 财务统计表
export const GetSaleOutMasterGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetSaleOutMasterGroup`, { params: params });
};
// 财务统计表导出
export const DownSaleOutMasterGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownSaleOutMasterGroup`, params, title);
};
// 收款统计表
export const GetDebitReport = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetDebitReport`, { params: params });
};
// 收款统计表导出
export const DownGetDebitReport = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownGetDebitReport`, params, title);
};

//财务工程备注新增
export const addProjectRemark = (params) => {
  return Request.post(`${BaseApiUrl}/api/ProjectRemark/Post`, params);
};

//获取所有泵车司机信息
export const GetPumpingSetting = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetPumpingSetting`, { params: params });
};

// 总计应收统计表
export const GetProjectDebitDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProjectDebitDetail`, { params: params });
};
// 总计应收统计表-导出
export const DownGetProjectDebitDetail = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownGetProjectDebitDetail`, params, title);
};

// 月度销售信息
export const GetProjectMonth = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProjectMonth`, { params: params });
};
// 月度销售信息-导出
export const DownGetProjectMonth = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownGetProjectMonth`, params, title);
};
// 收款统计表
export const GetDebitGroupReport = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetDebitGroupReport`, { params: params });
};
// 收款统计表导出
export const DownGetDebitGroupReport = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownGetDebitGroupReport`, params, title);
};
// 车辆出车统计表
export const GetProdVehicleGroup = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdVehicleGroup`, { params: params });
};
// 车辆出车统计表-导出
export const DownProdVehicleGroup = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdVehicleGroup`, params, title);
};
// 获取手动耗料
export const GetProdManDataSummary = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetProdManDataSummary`, { params: params });
};

// 导出手动耗料
export const DownProdManDataSummary = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownProdManDataSummary`, params, title);
};

// html内容导出
export const DownExportExcel = (params, title) => {
  return postExportExcel(`${BaseApiUrl}/api/Command/ExportExcel`, params, title);
};

// 每盘耗料报表
export const GetReportManufactureInfo = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetReportManufactureInfo`, { params: params });
};
// 每盘耗料报表-导出
export const DownReportManufactureInfo = (params, title) => {
  return getExportExcel(`${BaseApiUrl}/api/Command/DownReportManufactureInfo`, params, title);
};
